import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { useValidationErrorHandle } from "sr/helpers/functions/validationErrorHandle";
import { getPaymentTerms } from "sr/utils/api/masterData/getPaymentTerms";
import { FormattedMessage } from "react-intl";

type Props = {
  data: { payment_terms?: string };
  HandleDataProps: (payload: { payment_terms: string }) => void;
};

const BidPaymentTermsChange = forwardRef(({ data, HandleDataProps }: Props, ref) => {
  const [terms, setTerms] = useState("");
  const [errorId, setErrorId] = useState<string>("");
  const validationErrorHandle = useValidationErrorHandle();
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);

  useEffect(() => {
    setTerms(data?.payment_terms || "");
  }, [data?.payment_terms]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getPaymentTerms();
        if (res?.success && Array.isArray(res.data)) {
          const mapped = res.data.map((item: any) => ({
            value: item.value,
            label: item.label,
          }));
          setOptions(mapped);
        }
      } catch {}
    };
    load();
  }, []);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!terms) { setErrorId('INPUT.VALIDATION.BID.PAYMENT_TERMS'); return false; }
      setErrorId('');
      return true;
    },
    submitForm: () => {
      const newData = { payment_terms: terms };
      HandleDataProps(newData);
      return newData;
    },
  }));

  return (
    <div>
      <p className="pt-4 text-base">Payment Terms</p>
      <select
        className="w-full border rounded-lg p-2 mt-2"
        value={terms}
        onChange={(e) => setTerms(e.target.value)}
      >
        <option value="">Select Terms</option>
        {(options.length
          ? options
          : [
              { value: "60_40", label: "CORPORATE.RECRUITMENT.JOB.PAYMENTTERMS.SIXTY_ADVANCE_FORTY_COMPLETION" },
              { value: "30_70", label: "CORPORATE.RECRUITMENT.JOB.PAYMENTTERMS.THIRTY_ADVANCE_SEVENTY_COMPLETION" },
              { value: "milestone_based", label: "CORPORATE.RECRUITMENT.JOB.PAYMENTTERMS.MILESTONE_BASED" },
              { value: "after_completion", label: "CORPORATE.RECRUITMENT.JOB.PAYMENTTERMS.AFTER_COMPLETION" },
            ]
        ).map((opt) => (
          <option key={opt.value} value={opt.value}>
            <FormattedMessage id={opt.label} defaultMessage={opt.label} />
          </option>
        ))}
      </select>
      {errorId && <div className="text-red-500 text-sm mt-2">{validationErrorHandle(errorId)}</div>}
    </div>
  );
});

export default BidPaymentTermsChange;
